/**
 * @generated SignedSource<<e713c0fa0023fb98caee237cb4d2a1c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobilePageHeader_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerIncentives_item">;
  readonly " $fragmentType": "CheckoutMobilePageHeader_item";
};
export type CheckoutMobilePageHeader_item$key = {
  readonly " $data"?: CheckoutMobilePageHeader_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobilePageHeader_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobilePageHeader_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerIncentives_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "79a1c6a7a711dbbb771785597a0f0e6d";

export default node;
